var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__checkmark--system icon--style--outline icon--size--small",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"}},[_c('path',{attrs:{"d":"M6.131 13.745a.75.75 0 01-.531-.22l-4.38-4.38a.751.751 0 111.061-1.063l3.791 3.791 7.608-9.364a.751.751 0 011.165.946L6.712 13.466a.751.751 0 01-.544.277z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }